import React, { Suspense, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getSelectedEvent } from '@b/checkout/selectors/event';

const Protect = React.lazy(() => import('./Protect'));

class ProtectWrapper extends Component {
    getSeatLabel = (seatInfo) => {
      let startWithComma = false;
      let _seat_info = '';
      if (!seatInfo?.row && !seatInfo?.seat){
        return '';
      }

      // eslint-disable-next-line no-extra-boolean-cast
      if (!!seatInfo?.section){
          _seat_info += 'Sec ' + seatInfo.section;
          startWithComma = true;
      }

      const placeType = seatInfo?.isTableSeat ? 'Table' : 'Row';
      _seat_info += `${startWithComma ? ', ' : ''}${placeType} ${seatInfo.row}`;

      if (seatInfo?.isTableSeat || seatInfo?.row) {
        startWithComma = true;
      }
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!seatInfo?.seats) {
          _seat_info += (startWithComma? ', ':'') + 'Seat(s) ' + seatInfo.seats;
      }

      return _seat_info;
    }

    getFields() {
        const tickets = this.props.tickets.map((ticket) => {
          const seatLabel = this.getSeatLabel(ticket.seat_info);

          const result = {
            [`ticket-${ticket.id}_eventId`]: this.props.selectedEvent?.event_id,
            [`ticket-${ticket.id}_eventName`]: this.props.selectedEvent?.name,
            [`ticket-${ticket.id}_eventCategory`]: this.props.selectedEvent?.category ?? '',
            [`ticket-${ticket.id}_eventCity`]: this.props.selectedVenue?.address?.city,
            [`ticket-${ticket.id}_eventCountry`]: this.props.selectedVenue?.address?.country,
            [`ticket-${ticket.id}_eventOrganiser`]: this.props.organizer,
            [`ticket-${ticket.id}_venueName`]: this.props.selectedVenue?.name,
            [`ticket-${ticket.id}_priceLevel`]: ticket.price_level_name,
          };

          if (seatLabel) {
            result[`ticket-${ticket.id}_seatInfo`] = seatLabel;
          }

          return result;
        });

        const products = this.props.productSales.map((product) => ({
          [`product-${product.id}_eventId`]: this.props.selectedEvent?.event_id,
          [`product-${product.id}_eventName`]: this.props.selectedEvent?.name,
          [`product-${product.id}_eventCategory`]: this.props.selectedEvent?.category ?? '',
          [`product-${product.id}_eventCity`]: this.props.selectedVenue?.address?.city,
          [`product-${product.id}_eventCountry`]: this.props.selectedVenue?.address?.country,
          [`product-${product.id}_eventOrganiser`]: this.props.organizer,
          [`product-${product.id}_venueName`]: this.props.selectedVenue?.name,
          [`product-${product.id}_productName`]: product.product_name,
        }));

      const bundles = this.props.bundleSales.map((bundle) => ({
          [`bundle_sale-${bundle.id}_eventId`]: this.props.selectedEvent?.event_id,
          [`bundle_sale-${bundle.id}_eventName`]: this.props.selectedEvent?.name,
          [`bundle_sale-${bundle.id}_eventCategory`]: this.props.selectedEvent?.category ?? '',
          [`bundle_sale-${bundle.id}_eventCity`]: this.props.selectedVenue?.address?.city,
          [`bundle_sale-${bundle.id}_eventCountry`]: this.props.selectedVenue?.address?.country,
          [`bundle_sale-${bundle.id}_eventOrganiser`]: this.props.organizer,
          [`bundle_sale-${bundle.id}_venueName`]: this.props.selectedVenue?.name,
          [`bundle_sale-${bundle.id}_bundleName`]: bundle.name,
      }));

      const combinedList = [...tickets, ...products, ...bundles];
      return Object.assign({},...combinedList);
    }

    render() {
        return(
          <Suspense fallback={null}>
            <Protect
                selected={this.props.selected}
                price={this.props.price}
                loading={this.props.loading}
                declined={this.props.declined}
                onInsuranceChange={this.props.onInsuranceChange}
                widget_api_key={this.props.widget_api_key}
                version={this.props.version}
                sandbox={this.props.sandbox}
                templateId={this.props.templateId}
                insuranceItems={this.props.insuranceItems}
                currency={this.props.currency}
                locale={this.props.locale}
                setInsuranceOption={this.props.setInsuranceOption}
                mainEvent={this.props.mainEvent}
                mainVenue={this.props.mainVenue}
                reservation={this.props.reservation}
                seller_id={this.props.seller_id}
                seller_organization={this.props.seller_organization}
                itemsAsFields={this.getFields()}
            />
          </Suspense>
        );
    }
}

const mapStateToProps = (state) => {
    const selectedEvent = getSelectedEvent(state);

    return {
        version: state.version,
        selectedEvent: selectedEvent?.event,
        selectedVenue: selectedEvent?.venue,
        tickets: state.tickets.tickets,
        productSales: state.productSales.products,
        bundleSales: state.bundleSales.bundles,
        organizer: selectedEvent?.seller_organization
    };
};

export default connect(mapStateToProps)(ProtectWrapper);

ProtectWrapper.propTypes = {
    version: PropTypes.string
};
